<template slot-scope="scope">
  <!-- 企业邮箱更换 -->

      <dialogModel
        title="更换企业邮箱"
        :visible="dialogVisible"
        @handleClose="handleClose"
        @handleOk="handleEmail"
      >
        <div class="dialog-content">
            <div class="left-title">
              <div>当前邮箱：</div>

              <div><span style="color: red">*</span>新邮箱：</div>
              <div><span style="color: red">*</span>验证码：</div>
            </div>

            <div class="right-content">
              <div class="Current">
                {{ AccountInformation }}
              </div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <!-- 邮箱 -->
                <el-form-item prop="mail">
                  <div class="input-box">
                    <el-input
                      v-model="ruleForm.mail"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </el-form-item>

                <el-form-item prop="Code">
                  <div class="input-box code-field">
                    <el-input
                      v-model="ruleForm.Code"
                      placeholder="请输入"
                      class="code-input"
                    ></el-input>
                    <span
                      class="verify"
                      @click="second == 60 ? handelInvoke('ruleForm') : ''"
                    >{{
                      second === totalSecond && sendNum == 0
                        ? "获取验证码"
                        : second === totalSecond && sendNum != 0
                        ? "再次获取验证码"
                        : second + `s`
                    }}</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
      </dialogModel>

</template>

<script>
// 引入接口
import {
  postSendAuthCode, // 获取邮箱/手机验证码
} from "../../../../../assets/api/index";
import { updateCompanyMail } from "../../../../../assets/api/firm/firmCenter";

// 封装的表单验证
import { vxRule } from "../../../../../../untils/FormValidation/validate-form";

// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogVisible: {},
    AccountInformation: {}, //父组件通过调用接口获取的账号信息(手机号、邮箱)
  },
  components: {},
  data() {
    return {
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      ruleForm: {
        Code: "", // 验证码
        mail: "", // 邮箱
      },
      rules: {
        Code: vxRule(true, "", ["blur", "change"], "请输入验证码"),
        // input: vxRule(true, "MobileOrPhone", ["blur", "change"]),
        // mail: vxRule(true, "Email", ["blur", "change"]),
        mail: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的邮箱",
            trigger: ["blur", "change"],
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
        ],
      }, // 表单验证

      // 添加屏蔽公司检索公司名要用到的
    };
  },
  watch: {
    // 监听
    dialogVisible: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            Code: "", // 验证码
            mail: "", // 邮箱
          };
          // 关闭验证码倒计时 数据归位
          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.sendNum = "0";

          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  mounted() {},
  methods: {
    handelInvoke(formName) {
      this.$refs[formName].validateField("mail", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
        } else {
          this.postSendAuthCode();
        }
      });
    },
    postSendAuthCode() {
      // 获取验证码接口
      var data = {};
      data.data = {
        mail: this.ruleForm.mail,
        type: 1,
        authCodeBusiness: "9",
      };
      postSendAuthCode(data).then((res) => {
        if (res.code == 0) {
          this.Countdown();
          this.$tool.PromptBox("success", "验证码已发送");
        } else {
          // 验证码发送失败
          // this.$tool.PromptBox("error", "验证码发送失败");
        }
      });
    },
    // -------------------------------- 发送验证码倒计时----------------------
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },
    // 取消/关闭弹窗
    handleClose() {
      this.$emit("handleClose");
    },

    // 绑定邮箱
    handleEmail() {
      if (!this.$refs.ruleForm) {
        this.$tool.PromptBox("error", "表单实例不存在，请重试");
        return;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 使用标准邮箱格式正则表达式校验
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (emailRegex.test(this.ruleForm.mail)) {
            const data = {
              data: {
                mail: this.AccountInformation,
                newMail: this.ruleForm.mail,
                authCode: this.ruleForm.Code,
              },
            };
            updateCompanyMail(data).then((res) => {
              if (res.data.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleUnderstand");
              }
            });
          } else {
            this.$tool.PromptBox("error", "邮箱格式验证失败");
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  line-height: 35px !important;
  border: 1px solid #409eff ;
}
/deep/.el-input {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
}

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.dialog-content {
    width: 600px;
    min-height: 100px;
    margin: 0 auto;
    display: flex;

    .left-title {
      min-width: 110px;
      flex-shrink: 0;
      text-align: right;
      div {
        height: 35px;
        line-height: 35px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        text-align: right;
        font-weight: 400;
        margin-bottom: 30px;
        white-space: nowrap;
      }
    }

    .right-content {
      flex: 1;
      .Current {
        height: 35px;
        line-height: 35px;
      }
      .input-box {
        width: 350px;
        height: 35px;
        line-height: 35px;
        margin-top: 30px;
        // margin-bottom: 30px;
        display: flex;
        position: relative;
        .verify {
          position: absolute;
          right: 12px;
          top: 0;
          bottom: 0;
          height: 35px;
          line-height: 35px;
          display: inline-flex;
          align-items: center;
          color: #409eff;
          cursor: pointer;
          white-space: nowrap;
          font-size: 14px;
          z-index: 2;
          user-select: none;
        }
      }
      .code-field {
        .code-input {
          width: 100%;
          height: 35px !important;
          line-height: 35px !important;
          /deep/ .el-input__inner {
            height: 35px !important;
            line-height: 35px !important;
            padding-right: 100px;
          }
        }
      }
    }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
